import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import dropdownReport from 'img/dropdown-report.svg';
import dropdownChangeUser from 'img/dropdown-change-user.svg';
import dropdownCte from 'img/icon-ct-e-menu-lateral.svg';
import dropdownAddUser from 'img/dropdown-add-user.svg';
import dropdownMissingLetters from 'img/dropdown-missing-letters.svg';
import dropdownLogout from 'img/dropdown-logout.svg';
import dropdownOpenProtocol from 'img/dropdown-open-protocol.svg';
import dropdownProtocol from 'img/dropdown-protocol.svg';
import dropdownTicket from 'img/dropdown-ticket.svg';
import dropdownQuote from 'img/dropdown-quote.svg';

import SwitchComponent from 'components/SwitchComponent';
import UserManager from 'components/UserManagerSlider';
import { useCustomEvent } from 'components/ApplicationInsights';
import { DropdownCustomers } from '../DropdownCustomers';
import SearchHeader from '../SearchHeader';
import {
  abrirProtocoloAction,
  alterarCadastroAction,
  cartasDeFaltaAction,
  cotacoesAction,
  dadosClienteAction,
  EnumShippingCompany,
  eventName,
  gerenciarUsuariosAction,
  gerenciarUsuariosViveoAction,
  pedidosAction,
  protocolosAction,
  relatoriosAction
} from 'components/ApplicationInsights/eventNames';
import { Visibility } from 'components/Visibility';
import Text from '../../Text';

import { EnumUserType, IUser } from 'models/User';

import AuthServices from 'core/authentication/authService';
import { SelectCustomerIdIsArray } from 'utils/SelectCustomerIdIsArray';

import { useLoadCte } from 'hooks/useLoadCte';

import './styles.scss';
import { isMobileDevice } from 'utils/ScreenUtils';

const Dropdown: React.FC<{ closeDropdown: any; }> = ({ closeDropdown }) => {

  const { hasCte } = useLoadCte();

  const user = useSelector((state: { user: IUser; }) => state.user);
  const [eventClick, setEventClick] = useState('');
  const [actionClick, setActionClick] = useState('');
  const _authServices = new AuthServices();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;

  const componentName = `Menu Header`;
  const trackMenuClick = useCustomEvent(componentName, actionClick);
  const slider = useSelector((state: RootState) => state.slider);
  const isMobile = isMobileDevice();

  async function onUserRequestLogout() {
    try {
      await _authServices.logout();
    } catch (err) {
      alert(err);
    }
  }

  useEffect(() => {
    if (slider?.title) {
      eventClick !== '' && trackMenuClick({ item: slider?.title });
    }
  }, [slider]);

  function setOpenProtocolPath() {
    if (location.pathname === '/abrir-protocolo') {
      return window.location.reload();
    }

    eventClick !== '' && trackMenuClick({ item: abrirProtocoloAction.MENU_ABRIRPROTOCOLO });

    return navigate('/abrir-protocolo');
  }

  useEffect(() => {
    const main = document.querySelector('main');
    main?.addEventListener('click', closeDropdown);

    eventClick !== '' && trackMenuClick({ item: eventClick });

    return () => main?.removeEventListener('click', closeDropdown);
  }, [closeDropdown]);

  function onDropdownClick(func: any) {
    closeDropdown();
    func();

    localStorage.removeItem('firstTimeClickDownloadInLot');
  }

  function onDropdownClickEvent(event: any, action: any) {
    closeDropdown();
    setEventClick(event);
    setActionClick(action);
  }

  function onDropdownClickOpenProtocol(event: any, action: any) {
    closeDropdown();
    setOpenProtocolPath();
    setEventClick(event);
    setActionClick(action);
  }

  function openSliderDropdownUser(event: any, action: any) {
    closeDropdown();

    dispatch({
      type: 'OPEN_SLIDER',
      data: {
        title: 'Alterar Cadastro',
        content: UserManager,
      },
    });

    setEventClick(event);
    setActionClick(action);
  }

  function viewMenuCoverage() {
    let viewMenu = false;
    if (user?.email && user?.email === "ccareadm@mafrahospitalar.com.br") {
      viewMenu = true;
    }

    return viewMenu && (
      <li>
        <Link
          onClick={() => onDropdownClickEvent(
            dadosClienteAction.MENU_RELATORIOSTESTE,
            eventName.COVERAGE
          )}
          to="/relatorio-testes-unitarios"
          className="d-flex dropdown-link"
        >
          <img
            src={dropdownReport}
            alt=""
            style={{ width: 20, height: 20 }}
          />
          <Text size={14} className="color-blue-gray ml-2">
            Relatórios de Teste
          </Text>
        </Link>
      </li>
    );
  }

  function viewMenuQuotations() {
    const linkMenu = user.userType && user.userType === 'customer' ? '/cotacoes' : '/cotacoes-dashboard';

    return (
      <li>
        <Link
          onClick={() => onDropdownClickEvent(
            cotacoesAction.MENU_COTACOES,
            eventName.COTACOES
          )}
          to={linkMenu}
          className="d-flex dropdown-link"
        >
          <img src={dropdownQuote} alt="" style={{ width: 20, height: 20 }} />
          <Text size={14} className="color-blue-gray ml-2">
            Cotações
          </Text>
        </Link>
      </li>
    );
  }

  function renderOrderMenuItem() {
    return (<li>
      <Link
        onClick={() => onDropdownClickEvent(
          pedidosAction.MENU_PEDIDOS,
          eventName.PEDIDOS
        )}
        to="/pedidos"
        className="d-flex dropdown-link"
      >
        <img
          src={dropdownTicket}
          alt=""
          style={{ width: 20, height: 20 }}
        />
        <Text size={14} className="color-blue-gray ml-2">
          Pedidos
        </Text>
      </Link>
    </li>);
  }

  function renderRegisterMenuItem() {
    return (<li>
      <Link
        onClick={() => openSliderDropdownUser(
          alterarCadastroAction.MENU_ALTERARCADASTRO,
          eventName.ALTERAR_CADASTRO
        )}
        to={currentPath}
        className="d-flex dropdown-link"
      >
        <img
          src={dropdownChangeUser}
          alt=""
          style={{ width: 20, height: 20 }}
        />
        <Text size={14} className="color-blue-gray ml-2">
          Alterar cadastro
        </Text>
      </Link>
    </li>);
  }

  function renderUserManagerMenuItem() {
    return (<li>
      <Link
        onClick={() => onDropdownClickEvent(
          gerenciarUsuariosViveoAction.MENU_GERENCIARUSUARIOSVIVEO,
          eventName.GERENCIAR_USUARIOS_VIVEO
        )}
        to="/gerenciar-usuarios-grupo"
        className="d-flex dropdown-link"
      >
        <img
          src={dropdownAddUser}
          alt=""
          style={{ width: 20, height: 20 }}
        />
        <Text size={14} className="color-blue-gray ml-2">
          Gerenciar usuários
        </Text>
      </Link>
    </li>);
  }

  function renderMenuItemsForSupplier() {
    return (
      <>
        {renderOrderMenuItem()}
        {renderRegisterMenuItem()}
        {user.roles?.some(role => role === 'administrator') && renderUserManagerMenuItem()}
      </>
    );
  }

  const viewMenuShippingCompany = () => {
    if (!user.userType)
      return false;

    return hasCte;
  };


  return (
    <div className="dropdown-main-div">
      <ul className="dropdown-main-list">
        <Visibility visible={!isMobile}>
          {user.userType === EnumUserType.SUPPLIER ? renderMenuItemsForSupplier() : (
            <>
              <SwitchComponent roles={['administrator', 'member']} type={['customer']}>
                <li className="dropdown-search-header customer-drop">
                  <DropdownCustomers {...user} dropdown />
                </li>
              </SwitchComponent>
              <SwitchComponent roles={['administrator']} type={['employee']}>
                <li className="dropdown-search-header search-align">
                  <SearchHeader hide closeDropdown={() => closeDropdown()} />
                </li>
              </SwitchComponent>
              <li>
                <Visibility visible={Array.isArray(user?.selectedCustomerId)}>
                  <div
                    className="d-flex dropdown-link cursor-pointer"
                    onClick={() => !SelectCustomerIdIsArray()}
                    id="open-protocol"
                  >
                    <img
                      src={dropdownOpenProtocol}
                      alt=""
                      style={{ width: 20, height: 20 }}
                    />
                    <Text size={14} className="color-blue-gray ml-2">
                      Abrir protocolo
                    </Text>
                  </div>
                </Visibility>
                <Visibility visible={!Array.isArray(user?.selectedCustomerId)}>
                  <Link
                    onClick={() => onDropdownClickOpenProtocol(
                      abrirProtocoloAction.MENU_ABRIRPROTOCOLO,
                      eventName.PROTOCOLOS
                    )}
                    to="/abrir-protocolo"
                    className="d-flex dropdown-link"
                    id="open-protocol"
                  >
                    <img
                      src={dropdownOpenProtocol}
                      alt=""
                      style={{ width: 20, height: 20 }}
                    />
                    <Text size={14} className="color-blue-gray ml-2">
                      Abrir protocolo
                    </Text>
                  </Link>
                </Visibility>
              </li>

              <li>
                <Link
                  onClick={() => onDropdownClickEvent(
                    protocolosAction.MENU_PROTOCOLOS,
                    eventName.PROTOCOLOS
                  )}
                  to="/protocolos"
                  className="d-flex dropdown-link"
                >
                  <img
                    src={dropdownProtocol}
                    alt=""
                    style={{ width: 20, height: 20 }}
                  />
                  <Text size={14} className="color-blue-gray ml-2">
                    Protocolos abertos
                  </Text>
                </Link>
              </li>

              {renderOrderMenuItem()}

              {viewMenuQuotations()}

              <Visibility visible={viewMenuShippingCompany()}>
                <li>
                  <Link
                    onClick={() => onDropdownClickEvent(EnumShippingCompany.MENU_TRANSPORTADORA, eventName.TRANSPORTADORA)}
                    to="/cte"
                    className="d-flex dropdown-link"
                  >
                    <img
                      src={dropdownCte}
                      alt=""
                      style={{ width: 20, height: 20 }}
                    />
                    <Text size={14} className="color-blue-gray ml-2">
                      Healthlog
                    </Text>
                  </Link>
                </li>
              </Visibility>

              <SwitchComponent roles={['administrator', 'member']} type={['customer']}>
                {renderRegisterMenuItem()}
              </SwitchComponent>

              <Visibility visible={!!user.selectedCustomerId}>
                <li>
                  <Visibility visible={Array.isArray(user?.selectedCustomerId)}>
                    <div
                      className="d-flex dropdown-link cursor-pointer"
                      onClick={() => !SelectCustomerIdIsArray()}
                    >
                      <img
                        src={dropdownChangeUser}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                      <Text size={14} className="color-blue-gray ml-2">
                        Dados do Cliente
                      </Text>
                    </div>
                  </Visibility>
                  <Visibility visible={!Array.isArray(user?.selectedCustomerId)}>
                    <Link
                      onClick={() => onDropdownClickEvent(dadosClienteAction.MENU_DADOSCLIENTE, eventName.DADOS_CLIENTE)}
                      to="/dados-cliente"
                      className="d-flex dropdown-link"
                    >
                      <img
                        src={dropdownChangeUser}
                        alt=""
                        style={{ width: 20, height: 20 }}
                      />
                      <Text size={14} className="color-blue-gray ml-2">
                        Dados do Cliente
                      </Text>
                    </Link>
                  </Visibility>
                </li>
              </Visibility>

              <SwitchComponent roles={['administrator']} type={['customer']}>
                <li>
                  <Link
                    onClick={() => onDropdownClickEvent(
                      gerenciarUsuariosAction.MENU_GERENCIARUSUARIOS,
                      eventName.GERENCIAR_USUARIOS
                    )}
                    to="/gerenciar-usuarios"
                    className="d-flex dropdown-link"
                  >
                    <img
                      src={dropdownAddUser}
                      alt=""
                      style={{ width: 20, height: 20 }}
                    />
                    <Text size={14} className="color-blue-gray ml-2">
                      Gerenciar usuários
                    </Text>
                  </Link>
                </li>
              </SwitchComponent>

              <SwitchComponent roles={['administrator']} type={['employee']}>
                {renderUserManagerMenuItem()}
              </SwitchComponent>

              <SwitchComponent roles={['administrator']} type={['employee']}>
                <li>
                  <Link
                    onClick={() => onDropdownClickEvent(
                      cartasDeFaltaAction.MENU_CARTASDEFALTA,
                      eventName.CARTAS_DE_FALTA
                    )}
                    to="/cartas-falta"
                    className="d-flex dropdown-link"
                  >
                    <img
                      src={dropdownMissingLetters}
                      alt=""
                      style={{ width: 20, height: 20 }}
                    />
                    <Text size={14} className="color-blue-gray ml-2">
                      Cartas de faltas
                    </Text>
                  </Link>
                </li>
              </SwitchComponent>

              <SwitchComponent roles={['administrator']} type={['employee']}>
                <li>
                  <Link
                    onClick={() => onDropdownClickEvent(
                      relatoriosAction.RELATORIO_USUARIOS,
                      eventName.RELATORIOS
                    )}
                    to="/relatorio-usuarios"
                    className="d-flex dropdown-link"
                  >
                    <img
                      src={dropdownReport}
                      alt=""
                      style={{ width: 20, height: 20 }}
                    />
                    <Text size={14} className="color-blue-gray ml-2">
                      Relatórios
                    </Text>
                  </Link>
                </li>
              </SwitchComponent>

              {viewMenuCoverage()}
            </>
          )}
        </Visibility>

        <li>
          <button
            onClick={() => onDropdownClick(onUserRequestLogout)}
            className="d-flex dropdown-link"
          >
            <img
              src={dropdownLogout}
              alt=""
              style={{ width: 20, height: 20 }}
            />
            <Text size={14} className="color-blue-gray ml-2">
              Deslogar
            </Text>
          </button>
        </li>
      </ul>
    </div>
  );
};
export default Dropdown;
